<template>
  <div class="complaintHandling">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="申诉编号">
        <template slot-scope="scope">
          <span>{{scope.row.appeal_no}}</span>
        </template>
      </el-table-column>
      <el-table-column label="申诉测试">
        <template slot-scope="scope">
          <span>{{scope.row.test_class_title}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="申诉类型" align="center">
            <template slot-scope="scope">
               <span>{{scope.row.appeal_type}}</span>
            </template>
      </el-table-column>-->
      <el-table-column label="申诉内容" width="240">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper" style="max-height:70px;overflow:auto">
            <div v-if="scope.row.appeal_content[0]">
              <span>首次申诉：</span>
              <br />
              <p>{{scope.row.appeal_content[0]}}</p>
            </div>
            <div v-if="scope.row.appeal_content[1]">
              <span>二次申诉：</span>
              <br />
              <p>{{scope.row.appeal_content[1]}}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申诉处理状态">
        <template slot-scope="scope">
          <span>{{scope.row.appeal_status|status}}</span>
        </template>
      </el-table-column>
      <el-table-column label="成绩修改状态">
        <template slot-scope="scope">
          <span>{{scope.row.edit_status|edit}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="5" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            @click="revise(scope.row)"
            type="text"
            size="small"
            v-if="scope.row.appeal_status == '0' || scope.row.edit_status == '0'"
          >修改成绩</el-button>
          <el-button
            @click="reject(scope.row)"
            type="text"
            size="small"
            v-if="scope.row.appeal_status == '0' || scope.row.edit_status == '0'"
          >驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" style="margin-top: 55px;text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount > 7"
      ></el-pagination>
    </div>
    <el-dialog title="修改成绩" :visible.sync="dialogTableVisible" :width="screenWidth>768?'40%':'90%'">
      <el-table :data="score_subject">
        <el-table-column label="科目" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.test_subject_id|subject }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成绩" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.score" class="input" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="loading">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="驳回理由"
      :visible.sync="dialogFormVisible"
      :width="screenWidth>768?'30%':'90%'"
      class="reject"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="处理意见" prop="appeal_reply">
          <el-input
            type="textarea"
            v-model="form.appeal_reply"
            placeholder="最多输入100个字"
            @input="descInput"
            maxlength="100"
          ></el-input>
          <p style="margin-top:5px">{{remnant}}/100</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTable('form')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetDicData } from "@/api/admin/common.js";
import {
  getAthleteData,
  UpdateAthleteAppeal,
  UpdateAthleteBHsAppeal,
  getAthleteDetails
} from "@/api/admin/test.js";
import { mapGetters } from "vuex";
//声明一个全局变量
let that;
export default {
  computed: {
    ...mapGetters(["screenWidth"])
  },
  data() {
    return {
      tableData: [],
      appeal_status: [],
      totalCount: 0,
      paging: {
        limit: 7,
        page: 1
      },
      score: {},
      dialogTableVisible: false,
      dialogFormVisible: false,
      score_subject: [],
      test_subject: [],
      edit_status: [],
      loading: false,
      form: {},
      rules: {
        appeal_reply: [
          { required: true, message: "请填写驳回理由", trigger: "blur" }
        ]
      },
      remnant: 100
    };
  },
  created() {
    this.getList();
    this.dicData();
  },
  methods: {
    dicData() {
      GetDicData({ classCode: "appeal_status" }).then(data => {
        if (data.data.result) {
          this.appeal_status = data.data.result;
        }
      });
      GetDicData({ classCode: "test_class_test_project_type" }).then(data => {
        if (data.data.result) {
          this.test_subject = data.data.result;
        }
      });
      GetDicData({ classCode: "edit_status" }).then(data => {
        if (data.data.result) {
          this.edit_status = data.data.result;
        }
      });
    },
    getList() {
      getAthleteData(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.totalCount = list.totalCount;
          this.tableData = [];
          for (var i = 0; i < list.items.length; i++) {
            list.items[i].appeal_content = list.items[i].appeal_content.split(
              "/"
            );
            this.tableData.push(list.items[i]);
          }
        }
      });
    },
    descInput() {
      var txtVal = this.form.appeal_reply.length;
      this.remnant = 100 - txtVal;
      if (this.remnant < 0) {
        this.remnant = 0;
      }
    },
    revise(row) {
      this.dialogTableVisible = true;
      getAthleteDetails({ id: row.id }).then(data => {
        var list = data.data.result;
        if (list) {
          this.score = list.items[0];
          this.score_subject = this.score.score_subject;
        }
      });
    },
    reject(row) {
      this.dialogFormVisible = true;
      this.form = row;
      this.getList();
    },
    submitTable(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          UpdateAthleteBHsAppeal(this.form)
            .then(data => {
              if (data.data.success) {
                if (data.data.result.isSuccess) {
                  this.getList();
                  this.dialogFormVisible = false;
                  this.$message({
                    type: "success",
                    message: "已驳回"
                  });
                }
              }
            })
            .catch(() => {
              this.dialogFormVisible = false;
            });
        } else {
          return false;
        }
      });
    },
    submit() {
      this.loading = true;
      UpdateAthleteAppeal(this.score).then(data => {
        
        if (data.data.success) {
          if (data.data.result.isSuccess) {
            (this.loading = false), (this.dialogTableVisible = false);
            this.getList();
          }
        }
      });
    },
    handleCurrentChange(page) {
      this.paging.page = page;
      this.getList();
    }
  },
  beforeCreate: function() {
    that = this;
  },
  filters: {
    status: data => {
      for (var i in that.appeal_status) {
        if (that.appeal_status[i].value == data) {
          return that.appeal_status[i].label;
        }
      }
    },
    subject: data => {
      for (var i in that.test_subject) {
        if (that.test_subject[i].value == data) {
          return that.test_subject[i].label;
        }
      }
    },
    edit: data => {
      for (var i in that.edit_status) {
        if (that.edit_status[i].value == data) {
          return that.edit_status[i].label;
        }
      }
    }
  }
};
</script>

<style lang="less">
.complaintHandling {
  .input {
    width: 100px;
    .el-input__inner {
      text-align: center;
      border-width: 0px !important;
      padding-right: 14px;
    }
  }
}
.reject {
  .el-dialog__body {
    padding: 0 20px;
    .el-textarea__inner {
      height: 100px;
      font-family: "微软雅黑";
    }
  }
}
</style>